/** Homepage sections (below hero) — mirrors PHP site_copy_page_defaults(). */
export const HOME_COPY_DEFAULTS = {
  collections_title: 'Our Beautiful Collections',
  collections_lead: 'Handpicked categories from our catalog — each opens the full collection.',
  shop_by_style_title: 'Shop by style',
  shop_by_style_lead:
    'Explore looks across Rakhi, Lumba, and more — every tile links to that style in your shop.',
  curated_title: 'Curated looks',
  curated_subtitle_featured: 'Hand-picked in Admin → Site → Featured.',
  curated_subtitle_default: 'Auto-filled from catalog — pick products in Admin → Site → Featured.',
  featured_title: 'Featured products',
  instagram_title: 'Explore Us',
  instagram_subtitle:
    'Follow our latest styling, customer moments, and festive inspiration on Instagram.',
  instagram_button: 'Visit our Instagram profile',
  instagram_empty: 'Product photos from your catalog will appear here.',
  exhibitions_eyebrow: 'Meet us in person',
  exhibitions_title: 'Exhibition schedule',
  exhibitions_subtitle:
    'Find when we are near you—browse by month or filter by city. We sell most of our collection at these shows.',
};

export const ABOUT_COPY_DEFAULTS = {
  story_heading: 'Our story',
  values_title: 'What we stand for',
  values_subtitle: 'The principles behind every piece we make.',
  values: [
    {
      icon: '🎨',
      title: 'Artisanal craftsmanship',
      desc: 'Every piece is hand-finished with meticulous attention to detail.',
    },
    {
      icon: '💝',
      title: 'Sacred traditions',
      desc: 'Honoring rituals and cultural meaning in modern celebrations.',
    },
    {
      icon: '✨',
      title: 'Modern elegance',
      desc: 'Contemporary designs that feel personal and festive.',
    },
  ],
  cta_lead: 'Ready to find your perfect piece?',
  cta_primary_label: 'Get in touch',
  cta_secondary_label: 'Browse the shop',
};

export const CONTACT_COPY_DEFAULTS = {
  eyebrow: 'Saloni Designs',
  hero_title: 'Get in touch',
  hero_subtitle: "We'd love to hear from you — custom orders, questions, or just hello.",
  hero_whatsapp_button: 'WhatsApp us',
  hero_shop_button: 'Browse the shop',
  reach_title: 'Reach us',
  reach_subtitle: 'Choose what works best for you.',
  form_title: 'Send a message',
  form_subtitle: 'Custom orders, bulk gifting, or general questions.',
  form_submit: 'Send message',
  hours_title: 'Business hours',
  cards: [
    { icon: '📞', title: 'Call us', desc: 'Speak directly with our team', link_label: '' },
    { icon: '✉️', title: 'Email us', desc: 'Questions or special requests', link_label: '' },
    { icon: '📍', title: 'Visit us', desc: 'Based in Gujarat, India', link_label: '' },
    { icon: '💬', title: 'WhatsApp', desc: 'Quick messages and order updates', link_label: 'Chat with us' },
  ],
};

export const PAGE_COPY_DEFAULTS = {
  home: HOME_COPY_DEFAULTS,
  about: ABOUT_COPY_DEFAULTS,
  contact: CONTACT_COPY_DEFAULTS,
};
